import React from "react";
import Alert from "@mui/material/Alert";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import Avatar from "@mui/material/Avatar";
import AddIcon from "@mui/icons-material/AddCircle";

const stringToColor = (string) => {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.substr(-2);
  }

  return color;
}

const getAvatar = name => {
  const prepositions = /\s(a|e|i|o|u|as|os|da|de|do|das|dos)/gi;
  const array = name.replace(/[^a-zA-Z0-9 ]/g, "").replace(prepositions, " ").split(" ").filter(x => x !== "");
  let result = array[0][0];
  if (array.length > 1) {
    result += array[1][0];
  }
  return result;
}

const noop = () => {}

export const SimpleList = React.memo(({ data = [], getItem = noop, secondaryActions = noop, onSelect }) => {
  const handleSelect = item => e => onSelect && onSelect(item, e);

  if (!data.length) {
    return (
      <Alert severity="info">
        <strong>Nada por aqui!</strong>{" "}
        Para começar clique em <AddIcon sx={{ verticalAlign: "middle" }} />
      </Alert>
    );
  }

  return (
    <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
      {data.map((item, index) => {
        const { key, primary, secondary } = getItem(item, index);

        return (
          <ListItem disablePadding key={key}>
            <ListItemButton onClick={handleSelect(item)}>
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: stringToColor(primary) }}>
                  {getAvatar(primary)}
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={primary} secondary={secondary} />
              <ListItemSecondaryAction>
                {secondaryActions(item)}
              </ListItemSecondaryAction>
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );
});
